export default __webpack_public_path__ + "static/media/person5.6b130150.jpg";